import classnames from 'classnames';
import { format, getYear } from 'date-fns';
import React from 'react';

import { MonthDropdown } from './MonthDropdown';
import { YearDropdown } from './YearDropdown';
import { useAuth } from '../../app/AuthorizationProvider';

interface DatePickerHeaderProps {
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  date: Date;
  minDate?: Date;
  maxDate?: Date;
  changeYear(year: number): void;
  changeMonth(month: number): void;
  decreaseMonth(): void;
  increaseMonth(): void;
}

export const DatePickerHeader: React.FC<DatePickerHeaderProps> = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  changeMonth,
  changeYear,
  minDate,
  maxDate,
}) => {
  const { localeObj } = useAuth();

  const navigationClasses = 'react-datepicker__navigation mt-0';

  const PreviousButton = (
    <button
      className={classnames(navigationClasses, 'react-datepicker__navigation--previous')}
      data-test-id="datepicker-navigation-previous"
      onClick={decreaseMonth}
      type="button"
    />
  );

  const NextButton = (
    <button
      className={classnames(navigationClasses, 'react-datepicker__navigation--next')}
      data-test-id="datepicker-navigation-next"
      onClick={increaseMonth}
      type="button"
    />
  );

  return (
    <div className="react-datepicker__header">
      {!prevMonthButtonDisabled && PreviousButton}
      {!nextMonthButtonDisabled && NextButton}
      <div data-test-id="datepicker-calendar:current-month-and-year" className="react-datepicker__current-month">
        {format(date, 'LLLL yyyy', {
          locale: localeObj,
        })}
      </div>
      <MonthDropdown onChange={changeMonth} date={date} minDate={minDate} maxDate={maxDate} />
      <YearDropdown
        onChange={changeYear}
        currentYear={getYear(date)}
        minYear={minDate ? getYear(minDate) : undefined}
        maxYear={maxDate ? getYear(maxDate) : undefined}
      />
    </div>
  );
};
